module.exports = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 6.667C16 4.642 14.372 3 12.364 3S8.727 4.641 8.727 6.667c0 2 1.59 3.625 3.563 3.665A5.051 5.051 0 0 1 8.727 11.8l.001 2.2C12.744 14 16 10.717 16 6.667zM0 14c4.017 0 7.273-3.283 7.273-7.333C7.273 4.642 5.644 3 3.636 3S0 4.641 0 6.667c0 2 1.589 3.625 3.563 3.665A5.053 5.053 0 0 1 0 11.8V14z\" fill-rule=\"evenodd\"/></svg>"


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/Icon/quotes.svg
// module id = 317
// module chunks = 0